import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { DashboardService } from 'src/app/includes/dashboard/dashboard.service';

@Component({
  selector: 'app-associated-provider-information',
  templateUrl: './associated-provider-information.component.html',
  styleUrls: ['./associated-provider-information.component.css']
})
export class AssociatedProviderInformationComponent implements OnInit {
  providerId: any;
  associatedProviders: any = [];
  dataSource = new MatTableDataSource([]);
  displayedColumns: any = [ 'first_name', 'last_name', 'email'];


  constructor(
    private _dashboardService: DashboardService,
    private _activatedRoute: ActivatedRoute,

  ) {
    this.providerId = this._activatedRoute.snapshot.paramMap.get('provider_id');
  }

  ngOnInit(): void {
    this.getAssociatedProviders();
  }

  getAssociatedProviders() {
    this._dashboardService.getP2PRelation(null, this.providerId).subscribe((response: any) => {
      if (response.data.assoc_provider_id) {
        this.associatedProviders = response.data.assoc_provider_id;
        this.dataSource.data = this.associatedProviders;
      }
      console.log("res", response.data);
    });
  }

}
